import * as React from "react";

function SvgUserPosition(props) {
  return (
    <svg data-name="Componente 17 \u2013 1" width={27} height={27} {...props}>
      <g data-name="Elipse 1" fill="#ee3b24" stroke="#fff" strokeWidth={2}>
        <circle cx={13.5} cy={13.5} r={13.5} stroke="none" />
        <circle cx={13.5} cy={13.5} r={12.5} fill="none" />
      </g>
    </svg>
  );
}

export default SvgUserPosition;
